import React, { useState, useEffect } from 'react';
import {
    Link
} from "react-router-dom";

import { Button, Typography } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined, SendOutlined } from '@ant-design/icons';
import AssessmentQuestion from "./AssessmentQuestion";
import PanelSpinner from "./PanelSpinner";

import { getPostAssessmentQuestions, insertPostAssessmentQuestions } from '../../actions/Assessment-action';
import { action } from '../../store';
const { Title } = Typography;

const PostAssessment = ({ postAssessmentQuestions, loading, inCompletePostAssessment, isPostAssessmentDone, correctPostAssessmentAnswers, userId, profileInfo }) => {
    useEffect(() => {
        // console.log(getPreAssessmentQuestions, "getPreAssessmentQuestions()");
        action(getPostAssessmentQuestions({ userId }));
    }, [])
    useEffect(() => {
        if (postAssessmentQuestions.length > 0) {
            let myState = { ...state, questions: postAssessmentQuestions }
            if (isPostAssessmentDone) {
                myState.layout = 2
            }
            setState(myState);
        }
    }, [postAssessmentQuestions, postAssessmentQuestions]);

    const [state, setState] = useState({
        layout: 0,
        activeQuestion: 0,
        questions: [
          
        ],
        showRed: false
    });
    const { layout, questions, activeQuestion, showRed } = state;
    const changeLayout = (stage) => {
        if(questions[activeQuestion] && ( !questions[activeQuestion].choices || !questions[activeQuestion].choices.length ) ) {
            const livequestion = questions[activeQuestion];
            setState({ ...state, layout: stage });
            action(insertPostAssessmentQuestions({
                user_id: userId,
                question_id: livequestion.id,
                score: livequestion.answer,
                assessment_type: "post",
                option: true
            }))
        } else {
            setState({ ...state, layout: stage });
        }
    }
    const changeQuestion = (changeIndex) => {
        let actQtn = activeQuestion + changeIndex
        if(questions[activeQuestion] && ( !questions[activeQuestion].choices || !questions[activeQuestion].choices.length ) ) {
            const livequestion = questions[activeQuestion];
            setState({ ...state, activeQuestion: actQtn });
            action(insertPostAssessmentQuestions({
                user_id: userId,
                question_id: livequestion.id,
                score: livequestion.answer,
                assessment_type: "post",
                option: true
            }))
        } else {
            setState({ ...state, activeQuestion: actQtn});
        }
    }
    const updateQuestion = (question, index) => {
        let qtns = questions
        qtns[index] = question
        setState({ ...state, questions: qtns });
        action(insertPostAssessmentQuestions({
            user_id: userId,
            question_id: question.id,
            score: question.answer,
            assessment_type: "post"
        }))
    }
    const updateQuestionAlone = (question, index) => {
        let qtns = questions
        qtns[index] = question
        setState({ ...state, questions: qtns });
    }
    const getAnsweredQuestions =() => {
        if(questions && questions.length) {
            let answered = questions.filter((question)=>{
                return question.answer
            })
            return answered
        }
        return undefined
    }
    const answeredCount = () => {
        return getAnsweredQuestions() ? getAnsweredQuestions().length : 0
    }
    const allQuestionAnswered = () => {
        let answered = getAnsweredQuestions()
        return (questions.length == answered.length ) ? true : false
    }
    const continueCourse = () => {
        if(allQuestionAnswered()) {
            changeLayout(2)
        } else {
            if(questions && questions.length) {
                let notanswered = questions.filter((question)=>{
                    return !question.answer
                })
                var elmnt = document.getElementById("ass-qst-"+notanswered[0].id);
                elmnt.scrollIntoView();
            }
            setState({ ...state, showRed: true });
        }
    }
    return (
        <>
            {
                loading && (<PanelSpinner></PanelSpinner>)
            }
            <Title level={5} style={{ textAlign: 'center', backgroundColor: '#87d068', textTransform: "uppercase", margin: "-24px -24px 24px -24px", padding: "5px 0", color: "white" }}>
                Post-Assessment
                 {
                    questions && questions.length && layout == 1 && (
                        <span style={{ float: "right", display: "inline-block", padding: "0 10px 0 10px" }}>{activeQuestion + 1}/{questions.length}</span>
                    )
                }
            </Title>
            {
                layout == 0 &&
                <div style={{ maxWidth: 800, margin: "0 auto", fontSize: 20, textAlign: 'center' }}>
                    <div>
                        Hello <strong>{profileInfo && profileInfo.name}</strong>,<br />
                        You have successfuly completed the "Virtual Youth Creative Art Camp" for postive mental health. Finally, you will be having post assessment which has<strong> {questions && questions.length} questions</strong> with<strong> multiple choices</strong>. You have to answer this question in a single session. If you have disconnected, you supposed retake the assessment.
                    </div>
                    <div style={{ marginTop: 24 }}>
                        <Button onClick={() => { changeLayout(1) }} type="primary" size="large" >
                            {
                                inCompletePostAssessment ? "Resume Assessment " : "Start Assessment "
                            }
                            <ArrowRightOutlined /> </Button>
                    </div>
                </div>
            }
            {
                layout == 1 &&
                <div style={{ maxWidth: 900, margin: "0 auto" }}>
                    {
                        questions &&
                        questions.map((question, index) => (
                             <div id={'ass-qst-'+question.id} className={ showRed && !question.answer ? "show-red" : ""}><AssessmentQuestion updateQuestion={updateQuestion} updateQuestionAlone={updateQuestionAlone} question={question} key={index} index={index} /></div>
                        ))
                    }
                    <div style={{ marginTop: 24 }}>
                     
                            <Button className="assessmentBtn" onClick={() => { continueCourse() }} style={{ minWidth: 100, float: "right", backgroundColor: '#87d068', color: "white" }} size="large" >Continue Camp <SendOutlined /> </Button>
                        
                    </div>
                </div>
            }
            {
                layout == 2 &&
                <div style={{ maxWidth: 800, margin: "0 auto", fontSize: 20, textAlign: 'center' }}>
                    <div>
                        Congratulations <strong>{profileInfo && profileInfo.name}</strong>!<br />
                        You have successfuly completed the post assessment of "Virtual Youth Creative Art Camp". Hope it will be a great learning for you to creat your own art. And please continue to submit your art work.
                    </div>
                    <div style={{ marginTop: 24 }}>
                        <Button href="https://www.tyclinternational.org/art-camp/#/user" type="primary" size="large" >Continue <ArrowRightOutlined /> </Button>
                    </div>
                </div>
            }

        </>
    )
}

export default PostAssessment